import {
  useContext,
  useEffect,
  useReducer,
  useState,
  createContext,
} from "react";
import { getLessonsFromAPI } from "../../common/service/service";
import { config } from "../../common/utilites/config";
import {
  SET_LESSONS,
  SET_CORRECT_ANSWER,
  SET_WRONG_ANSWER,
  SET_NET,
  RESET,
} from "../../common/utilites/types";
import {
  getLessonsFromLocalStorage,
  isOneHourLate,
  saveLessonsToLocalStorage,
} from "../../common/utilites/utilities";

const defaultValue = getLessonsFromLocalStorage(config.keyOfYKS) || {};

export const AppContext = createContext(defaultValue);
export const useAppContext = () => useContext(AppContext);
export function AppContextProvider({ children }: any) {
  const [allExamActive, setAllExamActive] = useState(false);
  const [tytExamActive, setTYTExamActive] = useState(true);
  const [aytExamActive, setAYTExamActive] = useState(false);
  const [ydtExamActive, setYDTExamActive] = useState(false);
  const [diplomaScore, setDiplomaScore] = useState(Number(0).toFixed(2));
  const [initialState, setInitialState] = useState(defaultValue);
  const [error, setError] = useState(false);
  const [lessonsLoading, setLessonsLoading] = useState(false);
  const [calculateLoading, setCalculateLoading] = useState<boolean>(false);
  const [examScore, setExamScore] = useState(Number(0).toFixed(2));

  useEffect(() => {
    if (allExamActive) {
      setTYTExamActive(true);
      setAYTExamActive(true);
      setYDTExamActive(true);
    }
  }, [allExamActive]);

  useEffect(() => {
    if (tytExamActive && aytExamActive && ydtExamActive) {
      setAllExamActive(true);
    } else if (!tytExamActive || !aytExamActive || !ydtExamActive) {
      setAllExamActive(false);
    }
  }, [tytExamActive, aytExamActive, ydtExamActive]);

  useEffect(() => {
    if (error) {
      alert("Bir hata oluştu daha sonra tekrar deneyiniz.");
    }
  }, [error]);

  useEffect(() => {
    if (
      Object.keys(initialState).length === 0 ||
      isOneHourLate(config.keyOfYKS)
    ) {
      setLessonsLoading(true);
      getLessonsFromAPI("tyt,ayt,ydt")
        .then(({ results }) => {
          results.forEach((item: any) => {
            item.wrong = 0;
            item.correct = 0;
            item.net = Number(0).toFixed(2);
          });
          const lessons = {
            TYT: results.filter((item: any) => item.test_name === "TYT"),
            AYT: results.filter((item: any) => item.test_name === "AYT"),
            YDT: results.filter((item: any) => item.test_name === "YDT"),
          };
          setInitialState(lessons);
          setError(false);
          saveLessonsToLocalStorage(lessons, "lessonsYKS");

          dispatch({
            type: SET_LESSONS,
            payload: lessons,
          });
        })
        .catch(() => setError(true))
        .finally(() => setLessonsLoading(false));
    }
  }, []);

  const reducer = (state: any, action: any) => {
    switch (action.type) {
      case SET_LESSONS: {
        const newState = { ...action.payload };

        return newState;
      }
      case SET_NET: {
        const tempLessonState = state[action.payload.testName].map(
          (item: any) => {
            if (item.id === action.payload.id) {
              return { ...item, net: action.payload.net };
            }

            return item;
          },
        );

        const newState = {
          ...state,
          [action.payload.testName]: tempLessonState,
        };

        return newState;
      }
      case SET_CORRECT_ANSWER: {
        const tempLessonState = state[action.payload.testName].map(
          (item: any) => {
            if (item.id === action.payload.id) {
              return { ...item, correct: action.payload.correct };
            }

            return item;
          },
        );

        const newState = {
          ...state,
          [action.payload.testName]: tempLessonState,
        };

        return newState;
      }
      case SET_WRONG_ANSWER: {
        const tempLessonState = state[action.payload.testName].map(
          (item: any) => {
            if (item.id === action.payload.id) {
              return { ...item, wrong: action.payload.wrong };
            }

            return item;
          },
        );

        const newState = {
          ...state,
          [action.payload.testName]: tempLessonState,
        };

        return newState;
      }
      case RESET: {
        setDiplomaScore(Number(0).toFixed(2));
        setExamScore("0");

        return initialState;
      }
      default:
        return state;
    }
  };

  const [state, dispatch] = useReducer(reducer, initialState);

  const contextValue = {
    allExamActive,
    setAllExamActive,
    tytExamActive,
    setTYTExamActive,
    aytExamActive,
    setAYTExamActive,
    ydtExamActive,
    setYDTExamActive,
    diplomaScore,
    setDiplomaScore,
    calculateLoading,
    setCalculateLoading,
    lessonsLoading,
    examScore,
    setExamScore,
    setError,
    state,
    dispatch,
  };

  return (
    <AppContext.Provider value={contextValue}>{children}</AppContext.Provider>
  );
}
